import { statusStyle } from "@/api/order";

export default function StatusPill({ status }: { status: string }) {
  const s = statusStyle[status] ?? { color: "#6B7280", bg: "#F3F4F6" };
  return (
    <span
      className="text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap"
      style={{ background: s.bg, color: s.color }}
    >
      {status}
    </span>
  );
}
